"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var LargeSpinnerSVG = function LargeSpinnerSVG(_ref) {
  var backgroundColor = _ref.backgroundColor,
    color = _ref.color,
    _ref$thickness = _ref.thickness,
    thickness = _ref$thickness === void 0 ? 0 : _ref$thickness;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "spinner-lg-svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 80 80",
    preserveAspectRatio: "xMaxYMax",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    strokeWidth: thickness,
    style: {
      fill: backgroundColor,
      stroke: backgroundColor
    },
    opacity: "0.5",
    fillRule: "evenodd",
    d: "M40 74C58.7777 74 74 58.7777 74 40C74 21.2223 58.7777 6 40 6C21.2223 6 6 21.2223 6 40C6 58.7777 21.2223 74 40 74ZM40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    strokeWidth: thickness,
    style: {
      fill: color,
      stroke: color
    },
    fillRule: "evenodd",
    d: "M37 2.99994C37 1.34308 38.3431 0 40 0C62.0914 0 80 17.9086 80 40C80 41.6569 78.6569 42.9999 77 42.9999C75.3431 42.9999 74 41.6568 74 39.9999C74 21.2223 58.7777 5.99994 40 5.99994C38.3431 5.99994 37 4.65679 37 2.99994Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    strokeWidth: thickness,
    style: {
      fill: color,
      stroke: color
    },
    fillRule: "evenodd",
    d: "M80 40C80 17.9086 62.0914 0 40 0C38.3431 0 37 1.34308 37 2.99994C37 4.65679 38.3431 5.99994 40 5.99994C58.7777 5.99994 74 21.2223 74 39.9999C74 41.6568 75.3431 42.9999 77 42.9999C78.6569 42.9999 80 41.6569 80 40Z"
  })));
};
var _default = exports["default"] = LargeSpinnerSVG;